// NPM Imports
import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Components Imports
import TempWFActions from "../TempWFActions";
import TempWFConditions from "../TempWFConditions";

export default class TempWFRuleWrapper extends Component {
  state = {
    isCollapsed: false,
  };

  render() {
    const { data, index } = this.props;
    return (
      <div className="tempworkflow-approvalwrapper-body" key={data.id}>
        <div className="tempworkflow-rule-title">
          Rule {index + 1}
          <div className="tempwfrulewrapper-action-wrapper">
            {index >= 1 && (
              <span
                className="tempwfrulewrapper-action-btn"
                onKeyPress={() => null}
                role="button"
                tabIndex="0"
                onClick={() => this.props.removeRule(data, index)}>
                <i>
                  <FontAwesomeIcon icon={["far", "trash-alt"]} />
                </i>
              </span>
            )}
            <span
              className="tempwfrulewrapper-action-btn"
              onKeyPress={() => null}
              role="button"
              tabIndex="0"
              onClick={() =>
                this.setState(prevState => ({
                  isCollapsed: !prevState.isCollapsed,
                }))
              }>
              <i>
                <FontAwesomeIcon
                  icon={[
                    "far",
                    `${this.state.isCollapsed ? "angle-down" : "angle-up"}`,
                  ]}
                />
              </i>
            </span>
          </div>
        </div>
        <div className="tempworkflow-approvalwrapper-split">
          <div className="tempworkflow-approvalwrapper-view">
            <TempWFConditions
              index={index}
              isCollapsed={this.state.isCollapsed}
              tempWFCondition={data.tempWFCondition || {}}
            />
          </div>
          <div className="tempworkflow-approvalwrapper-view">
            <TempWFActions
              index={index}
              isCollapsed={this.state.isCollapsed}
              tempWFAction={data.tempWFAction || {}}
              tempWFCondition={data.tempWFCondition || {}}
            />
          </div>
        </div>
      </div>
    );
  }
}
